import { useMemo } from 'react'
import { Layer, Source } from 'react-map-gl/maplibre'
import { LayerId, VisibleLayers } from '~/constants'
import { useAppStore, useRasterLoadTiming, useSederoManifest } from '~/hooks'
import { registerSederoColorFunction } from '~/util/cogConfig'

const SOURCE_ID = 'erosion-sedero'

export function ErosionLayer() {
  const { dataset, layerVisibility, getCosmosScenario } = useAppStore()
  const { urlByScenario } = useSederoManifest()

  const scenario = getCosmosScenario()
  const url = dataset === 'erosion' && scenario ? urlByScenario?.get(scenario) : undefined

  // useMemo, not useEffect: the colour function must be registered before <Source> mounts.
  useMemo(() => {
    if (url) registerSederoColorFunction(url)
  }, [url])

  useRasterLoadTiming('erosion', url)

  if (!url) return null

  const visible = layerVisibility[VisibleLayers.EROSION]

  return (
    <Source id={SOURCE_ID} type="raster" url={`cog://${url}`} tileSize={256}>
      <Layer
        id={LayerId.EROSION}
        type="raster"
        source={SOURCE_ID}
        beforeId={LayerId.BUILDING}
        layout={{ visibility: visible ? 'visible' : 'none' }}
        paint={{
          'raster-opacity': 0.85,
          // Hard-edged patch inside a nodata field; linear resampling smears the margin.
          'raster-resampling': 'nearest',
          'raster-fade-duration': 0,
        }}
      />
    </Source>
  )
}
